import AptisCard from "components/Aptis/AptisCard";
import React from "react";
import hero from "../media/habilidad_reading.jpg";
import Header from "components/Header";
import Contactanos from "components/Contactanos/Contactanos";
import AptisImg from "../media/aptis.webp";
import Button from "components/Buttons/Button";
import CallToAction from "components/CTA/CallToAction";

const Aptis = () => {
  const aptisVersions = [
    {
      icon: "fa-solid fa-apple-whole text-7xl",
      title: "Aptis General",
      description:
        "Evalúa el nivel de inglés desde A1 hasta C1, ideal para la comunicación cotidiana y laboral. Es aceptado por instituciones académicas.",
    },
    {
      icon: "fa-solid fa-crown text-7xl",
      title: "Aptis Advanced",
      description:
        "Mide habilidades de nivel superior como C1 y C2, adecuado para contextos académicos o profesionales. El contenido del examen es más complejo y exigente.",
    },
    {
      icon: "fa-solid fa-chalkboard-user text-7xl",
      title: "Aptis for Teachers",
      description:
        "Está diseñado para evaluar el nivel de inglés de docentes, con contenidos relacionados al entorno educativo.",
    },
    {
      icon: "fa-regular fa-futbol text-7xl",
      title: "Aptis for Teens",
      description:
        "se adapta a jóvenes de 13 a 17 años, con temas y situaciones apropiadas para su edad.",
    },
  ];

  const teachers = [
    {
      name: "Carolina Forero",
      img: "https://brightonenglishcenter.edu.co/img/Carolina_Forero.jpg",
    },
    {
      name: "Carlos Santacruz",
      img: "https://brightonenglishcenter.edu.co/img/Carlos-Santacruz.webp",
    },
    {
      name: "Patricia Rosales",
      img: "https://brightonenglishcenter.edu.co/img/Patricia-Rosales.webp",
    },
  ];
  const steps = [
    {
      num: "1. Regístrate",
      description:
        "Agenda tu fecha con nuestro personal. Te guiamos en cada paso del proceso.",
    },
    {
      num: " 2. Prepárate",
      description:
        "Accede a nuestro curso de preparacion y simulacros del examen APTIS.",
    },
    {
      num: "3. Preséntalo",
      description:
        "Realiza tu examen en nuestras instalaciones con ayuda de nuestro personal capacitado.",
    },
    {
      num: "4. Recibe Tus Resultados",
      description: "Obtén tu certificación oficial entre 2 a 3 días hábiles.",
    },
  ];
  const VersionCard = ({ icon, title, description }) => {
    return (
      <div
        className={`flex flex-col w-1/4 p-4 justify-center items-center rounded-lg gap-4 bg-cyan-50 rounded-tl-none shadow-[-10px_10px_0px_0px_#3b0764] text-purple-950`}
      >
        <i class={icon}></i>
        <p className="font-bold text-xl text-center ">{title}</p>
        <p className=" text-center text-lg text-purple-900">{description}</p>
      </div>
    );
  };
  const TeachersCard = ({ name, img }) => {
    return (
      <div className="group w-1/3 rounded-lg rounded-tl-none bg-white overflow-hidden shadow-[-10px_10px_0px_0px_#3b0764]">
        <img
          className="group-hover:scale-110 transition-all duration-300 ease-in-out object-cover h-full w-full"
          src={img}
          alt={name}
          width={400}
          height={800}
          title={`Instructor APTIS ${name}`}
          loading="lazy"
        />
      </div>
    );
  };
  return (
    <>
      <Header
        titulo="APTIS"
        info="¿Estás listo para demostrar tus habilidades en inglés y avanzar en tu carrera profesional o académica? En Brighton Centro de Inglés, te ofrecemos la preparación completa que necesitas para triunfar en el examen APTIS."
        linkToSection="/certificaciones/aptis#info"
        botonDescripcion="Conoce el examen"
        titleColor="#3b0764"
        infoColor="#581c87"
        buttonColor="#3b0764"
        buttonBg="#fccd01"
        img={AptisImg}
      />

      {/* Section: ¿Qué es APTIS? y preparate para presentarlo */}
      <section
        className=""
        id="info"
      >
        {/* Que es el examen */}
        <div className="flex flex-col lg:flex-row bg-yellow-1 items-center justify-center px-auto  h-[50vh] gap-10">
          <h2 className="w-full lg:w-1/3 text-4xl md:text-6xl text-right font-bold text-purple-950 font-Bebas leading-tight">
            ¿Qué es el examen APTIS?
          </h2>
          <div className="w-full lg:w-1/3 text-lg lg:text-3xl ">
            <p className="hyphens-none text-purple-900">
              <strong>APTIS</strong> es una herramienta diseñada por expertos
              del Concejo Británico para{" "}
              <em>
                evaluar las cuatro habilidades: producción oral, producción
                escrita, lectura y comprensión auditiva.
              </em>{" "}
              <strong>APTIS</strong> es un examen flexible, que se adapta a tus
              necesidades y es de fácil acceso.
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-10 items-center h-screen justify-center">
          <h3 className="text-6xl font-Bebas font-bold text-purple-950">
            Versiones del examen
          </h3>
          <p className="text-center text-2xl text-purple-900 w-1/2">
            El examen Aptis ofrece cuatro versiones diseñadas para adaptarse a
            tus necesidades específicas. Elige la versión que se ajuste a tus
            objetivos y a tu nivel actual de inglés.
          </p>
          <div className="w-3/4 flex flex-row gap-5">
            {aptisVersions.map((value, index) => (
              <VersionCard
                key={index}
                icon={value.icon}
                title={value.title}
                description={value.description}
              />
            ))}
          </div>
        </div>
        <div className="flex flex-row gap-10 w-full h-[80vh] bg-purple-950">
          <div className="flex flex-col justify-center items-end gap-10 w-full lg:w-1/2 text-right text-white">
            <h3 className="text-4xl md:text-6xl font-bold font-Bebas  tracking-wider w-3/4">
              Prepárate para el futuro
            </h3>
            <p className="text-2xl hyphens-none w-3/4">
              Brighton es un centro autorizado por{" "}
              <strong>British Council</strong> para realizar tu examen{" "}
              <strong>APTIS</strong>. Como centro oficial, garantizamos procesos
              certificados, instalaciones aprobadas y resultados reconocidos.
            </p>
            <p className="text-2xl w-3/4">
              Prepara tu examen <strong>APTIS</strong> con confianza. Realiza un{" "}
              <strong>examen diagnóstico</strong> en Brighton Centro de Inglés,
              evalúa tu nivel y preparate para obtener la puntuación que buscas.
            </p>
            <a
              href="https://wa.link/oy1he0"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Agenda tu examen diagnóstico APTIS"
            >
              <Button
                text="¡Agenda tu examen diagnóstico!"
                bgColor="#fccd01"
                color="#3b0764"
              />
            </a>
          </div>
          <div className="w-full lg:w-1/2 mx-4 md:mx-5 lg:mx-0 overflow-hidden rounded-lg rounded-tr-none">
            <img
              src={hero}
              alt="Examen diagnóstico APTIS - Brighton Centro de Inglés"
              className="object-cover h-full w-full "
              loading="lazy"
            />
          </div>
        </div>
      </section>

      {/* section: pasos para el registro , CTA*/}
      <section className="m-32">
        <div className="w-full flex flex-row justify-center items-start">
          <div className="w-1/2 space-y-4 relative mb-40">
            {steps.map((o, i) => (
              <div
                key={i}
                className={` sticky w-max top-1/4 transform -translate-y-1/3 transition-all duration-500`}
                style={{
                  // left: `${i * 30}px`,
                  transform: `translateY(${i * 20}px) translateX(${i * 20}px)`,
                  zIndex: i + 1,
                }}
              >
                <div className="p-10 bg-yellow-1  w-[400px] h-[400px] flex flex-col gap-10 justify-between rounded-lg rounded-tl-none border-solid border-4 border-purple-900">
                  <span className="text-5xl font-bold text-purple-950 font-Bebas">
                    {o.num}
                  </span>
                  <p className="text-2xl text-purple-900">{o.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="w-1/2 sticky top-1/3 h-full flex flex-col gap-10">
            <h2 className="font-Bebas text-6xl text-purple-950 font-bold">
              Presentar tu examen APTIS en Brighton
            </h2>
            <p className="text-purple-950 text-3xl">
              Certifica tu nivel de inglés con <strong>APTIS</strong> en <strong>Brighton Centro de Inglés.</strong> Realiza tu <strong>registro</strong> a través de nuestro <strong>formulario</strong> y prepárate para presentar la prueba con seguridad y respaldo profesional.
            </p>
            <a
              href="https://forms.gle/9NPaMprYyJnomp9G8"
              aria-label="Formulario de registro APTIS Brighton "
            >
              <Button
                bgColor="#fccd01"
                color="#3b0764"
                text={"¡Registrate Hoy!"}
              />
            </a>
          </div>
        </div>
      </section>

      {/* section: Curso de preparacion APTIS */}
      <section>
        <div className="p-32 bg-purple-950">
          <h2 className="text-8xl uppercase font-bold font-Bebas text-center text-white tracking-wide">
            Curso de Preparación
          </h2>
        </div>
        <div className="h-[80vh]">
          <img
            className="object-cover h-full w-full"
            src="https://brightonenglishcenter.edu.co/img/Graduados_2025.jpg"
            alt="Curso de preparación para el examen APTIS."
            width={1920}
            height={1080}
            loading="lazy"
            title="Comienza tu curso de preparacion para el examen APTIS en Brighton Centro de Ingles."
          />
        </div>
        <div className="bg-purple-950 p-32 flex flex-row justify-center items-start gap-10 text-white">
          <h3 className="text-6xl font-Bebas font-bold tracking-wider w-1/3  text-right">
            ¿Aún no has certificado tu inglés? APTIS es el siguiente paso.
          </h3>
          <p className="hyphens-none text-left text-base lg:text-3xl w-1/3 ">
            En <strong>Brighton Centro de Inglés</strong>, nos enfocamos en{" "}
            <em>
              desarrollar tus habilidades de inglés a un nivel académico
              superior.{" "}
            </em>
            No solo buscamos prepararte para el formato del examen{" "}
            <strong>APTIS</strong> y sus componentes. Nuestro objetivo es que
            apruebes el examen, que te sientas confiado y competente en
            cualquier situación académica o profesional que requiera el uso del
            idioma.
          </p>
        </div>
        <div className="p-32 flex flex-row justify-center items-start gap-10">
          <h3 className="text-6xl font-Bebas font-bold tracking-wide w-1/3 text-purple-950 text-right">
            Material Actualizado
          </h3>
          <p className="hyphens-none text-left text-base lg:text-3xl w-1/3 text-purple-900">
            Mantenemos{" "}
            <strong>
              <em>actualizado</em>
            </strong>{" "}
            nuestro material educativo para garantizar que recibas una educación
            de calidad que cumpla con los estándares más exigentes.{" "}
            <em>
              Nuestros recursos educativos están diseñados para ser dinámicos,
              relevantes y adaptados a las últimas actualizaciones del examen{" "}
              <strong>APTIS</strong>.
            </em>
          </p>
        </div>
        <div className="p-32 flex flex-col items-center  gap-10 bg-yellow-1">
          <h3 className="text-6xl font-Bebas font-bold tracking-wide w-fit text-purple-950">
            Profesores Expertos
          </h3>
          <p className="text-3xl w-1/2 text-center text-purple-900">
            Nuestro equipo de docentes expertos en la preparación de exámenes de
            certificación te guiara en tu proceso.
          </p>
          <div className="w-2/3 flex flex-row gap-5">
            {teachers.map((value, index) => (
              <TeachersCard key={index} name={value.name} img={value.img} />
            ))}
          </div>
        </div>
      </section>

      {/*  section: CTA */}
      <section className="p-32">
        <CallToAction
          text={
            "Habla con un asesor y comienza tu preparación con el respaldo de Brighton."
          }
          bgColor = "#3b0764"
          textColor ="#ffffff"
          buttonBgColor = "#fccd01"
          buttonColor = "#3b0764"
          linkTo={"https://wa.link/s8luux"}
        />
      </section>
      {/* Section: Versiones APTIS */}
      
    </>
  );
};
export default Aptis;
